import {z} from 'zod'

import {apiFetch} from 'src/api/fetch'
import {type LoadEntryInput, loadEntryRequestSchema} from 'src/jobs/loads/schemas'

import {driverFetch} from './driver-fetch'
import {
    type DriverJob,
    type DriverJobLoads,
    driverJobLoadsRawSchema,
    driverJobRawSchema,
    type DriverLink,
    driverLinkRawSchema,
    mapDriverJob,
    mapDriverJobLoads,
    mapDriverLink,
} from './schemas'

export async function getDriverJob(jobId: string, accessToken: string): Promise<DriverJob> {
    const raw = await driverFetch<unknown>(`/driver/jobs/${jobId}`, accessToken)
    return mapDriverJob(driverJobRawSchema.parse(raw))
}

export async function recordDriverLoads(
    jobId: string,
    accessToken: string,
    input: LoadEntryInput,
): Promise<DriverJobLoads> {
    const raw = await driverFetch<unknown>(`/driver/jobs/${jobId}/load-entries`, accessToken, {
        method: 'POST',
        body: JSON.stringify(loadEntryRequestSchema.parse(input)),
    })
    return mapDriverJobLoads(driverJobLoadsRawSchema.parse(raw))
}

/** Mint a driver link for each worker on the job. Idempotent. */
export async function mintDriverLinks(jobId: string): Promise<DriverLink[]> {
    const raw = await apiFetch<unknown>(`/jobs/${jobId}/driver-links`, {
        method: 'POST',
    })
    return z.array(driverLinkRawSchema).parse(raw).map(mapDriverLink)
}
